<template>
  <v-select
    v-bind:value="value"
    v-on:input="$emit('input', $event)"
    :items="clientes"
    :item-value="'id'" :item-text="'nombreCompleto'"
    label="Cliente"
    autocomplete cache-items
    :loading="loadingClientes"
    :search-input.sync="search"
    v-model="cliente" :required="required"
    :rules="clienteRules"
    hint="La búsqueda distingue entre mayúsculas y minúsculas">
    <template slot="item" slot-scope="data">
      <template>
        <v-list-tile-content>
          <v-list-tile-title >{{data.item.nombreCompleto}}</v-list-tile-title>
        </v-list-tile-content>
      </template>

    </template>
  </v-select>
</template>

<script>
    import Vue from 'vue';
    import Clientes from '../../services/clientes'

    export default Vue.extend({
      name: 'ClienteAutocompleteComponent',
      props: ['value','required'],
      data() {
        return {
          search: null,
          clientes: [],
          cliente: null,
          loadingClientes: false,
        }
      },
      watch: {
        search (val) {
          val && this.getClientes(val)
        },
        cliente(val) {
          this.$emit('input', val)
        }
      },
      computed: {
        requerido: function(){
          if (this.required != undefined) {
            return true
          } else {
            return false
          }
        },
        clienteRules: function(){
          if (this.requerido) {
            return [v => !!v || 'El Cliente es requerido']
          } else {
            return []
          }
        }
      },
      methods: {
        getClientes: _.debounce(async function (val) {
          this.loadingClientes = true
          if (val.length >= 3) {
            this.clientes = await Clientes.list(
              {
                populate: 'usuarioCreacion',
                where: JSON.stringify({
                  nombreCompleto: { contains: val.toUpperCase()},
                  activo: true
                }),
                select: 'nombreCompleto,tipo'
              })
              this.loadingClientes = false
          }
        }, 500),
      },
      beforeMount: async function() {
        if (this.value) {
          this.cliente = this.value.id
          this.clientes = [this.value]
        }
      }

    });
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/shared/ClienteAutocompleteComponent.vue